module.exports = __webpack_public_path__ + "img/activities-2.82997b25.jpg";